const KEY_VALUE_SEPARATOR = '||';

interface Hash {
  place_key: string;
  name: string;
}

const encodeArrayOfHashes = (arrayOfHashes: Hash[] | null | undefined) => {
  if (!arrayOfHashes) return null;
  return arrayOfHashes.map((entry) => [entry.place_key, entry.name].join(KEY_VALUE_SEPARATOR));
};

const decodeArrayOfHashes = (inputFromUrl: string | string[] | null | undefined) => {
  if (!inputFromUrl) return null;
  if (typeof inputFromUrl === 'string') {
    const elements = inputFromUrl.split(KEY_VALUE_SEPARATOR);
    return [
      {
        place_key: elements[0],
        name: elements[1],
      },
    ];
  }

  return inputFromUrl.map((hashAsString) => {
    const elements = hashAsString.split(KEY_VALUE_SEPARATOR);

    return {
      place_key: elements[0],
      name: elements[1],
    };
  });
};

const ArrayOfHashesParam = {
  encode: encodeArrayOfHashes,
  decode: decodeArrayOfHashes,
};

export { ArrayOfHashesParam, encodeArrayOfHashes, decodeArrayOfHashes, KEY_VALUE_SEPARATOR };
